import React, { useEffect } from "react";
import { Home, BuildingHospital, CaretRight, TrendingDown, Notebook, ClipboardCheck } from 'tabler-icons-react';
import btnHome from '../images/btnHomeIcon.png';

const Returncard = () => {



    useEffect(() => {


    }, []);
    return (
        <div className="topicSection">

            {/* HOME BUTTON SECTION */}
            <div className="btnHomeSection bounce-in-fwd10">
                <button type="button" className="btnCircle">
                    <img src={btnHome} alt="Date" height="50" width="50" /><br />
                    HOME
                </button>
            </div>

            <div className="headerSub">
                <div className="headerSubTitle scale-in-center">
                    <p>
                        PLEASE FOLLOWING THE INSTRUCTIONS
                    </p>
                </div>
            </div>

            <div className="headerName">
                <div className="headerTitle slide-in-top">
                    <div className="iconCardInfo"></div>
                    <div className="iconNameTitle">RETURN CARD</div>
                </div>
            </div>


            {/* MAIN CONTENT SECTION */}
            <div className="contentPage">

                {/* BREADCRUMBS */}
                <div className="breadcrumbs">
                    <ul>
                        <li className="fcolorGreen fade-in-left2"><Home size={50} strokeWidth={2} color={'green'} /> <span className="crumHome">HOME </span>
                            <TrendingDown size={25} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorGreen fade-in-left3"><BuildingHospital size={40} strokeWidth={2} color={'green'} />
                            <b><i> Step 1</i></b>
                            <br />
                            OPTION <CaretRight size={40} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorRed fade-in-left4"><Notebook size={40} strokeWidth={2} color={'red'} />
                            <b><i> Step 2</i></b> <br />
                            RETURN CARD <CaretRight size={40} strokeWidth={2} color={'red'} />
                        </li>
                        {/* <li className="fcolorGray fade-in-left5"><List size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 3</i></b> <br />
                            SUMMARY <CaretRight size={40} strokeWidth={2} color={'gray'} />
                        </li> */}
                        <li className="fcolorGray fade-in-left6"><ClipboardCheck size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 3</i></b> <br />
                            COMPLETE

                            {/* For White space */}
                            <CaretRight size={40} strokeWidth={2} color={'transparent'} />
                        </li>
                    </ul>

                </div>

                {/* BOX 1 - show media*/}
                <div className="iconSection3" id="idMediaBox">
                    <span>MEDIA</span>
                </div>



                {/* FORM SECTION  */}
                <div className="messageInfo spaceTopBtm fade-in-left3">
                    <p>
                        Please insert the card into the return slot.
                    </p>
                </div>


            </div>
        </div>
    );
};

export default Returncard;